'use client';
import { api } from '@/lib/providers/axios/api';
import { API_ROUTES } from '@/shared/constants/api-routes';
import { buildApiRoute } from '@/shared/functions/build-api-route';
import type { BaseDates } from '@/shared/interfaces/base-dates';

export interface Media extends BaseDates {
	id: string;
	mimetype: string;
	size: number;
	faqId?: string;
	userId?: string;
	bannerId?: string;
	productId?: string;
	url: string;
	redirectUrl?: string;
	icon: boolean;
	name: string;
}

export interface GetMediaBlobParams {
	media_id: string;
}
export default async function getMediaBlob({ media_id }: GetMediaBlobParams): Promise<Blob> {
	const res = await api.get(buildApiRoute(API_ROUTES.GET.PUBLIC.GET_MEDIA_BLOB, { media_id }), { responseType: 'blob' });
	return res.data;
}
